export default __webpack_public_path__ + "static/media/img3-carousel.cb144314.webp";